import { polygonPathGenerator } from "./pathGen";
export var polygonPathName = "polygonPathGenerator";
export function loadPolygonPath(engine) {
  engine.addPathGenerator(polygonPathName, polygonPathGenerator);
}